if (!customElements.get("bfcm-sale-products")) {
  class BfcmSaleProducts extends HTMLElement {
    // 轮播进度的计时器
    timer;
    pastTime = 0;
    slideTime = 0;

    constructor() {
      super();
      this.useSwiperPC = this.getAttribute('data-use_swiper_pc') == 'true';
      this.useSwiperPad = this.getAttribute('data-use_swiper_pad') == 'true';
      this.useSwiperMb = this.getAttribute('data-use_swiper_mb') == 'true';
      this.productRowsPc = this.getAttribute('data-product_rows_pc');
      this.productRowsSmallPc = this.getAttribute('data-product_rows_small_pc');
      this.productRowsPad = this.getAttribute('data-product_rows_pad');
      this.productRowsMb = this.getAttribute('data-product_rows_mb');
      this.useCountdown = this.getAttribute('data-use_countdown');
      this.loop = this.getAttribute('data-loop') == 'true';
      this.autoplay = this.getAttribute('data-autoplay') == 'true';
      this.swiperContainer = this.querySelector('.swiper-container');

      this.initSwiper();
      this.handleSwiperOnScreenWidth();
      window.addEventListener("resize", this.handleSwiperOnScreenWidth.bind(this));

      if (this.getAttribute('data-use_countdown') == 'true') {
        this.createCountdown();
      }

      this.slideTime = 5 * 1000;
      if (this.autoplay) {
        this.swiperContainer.addEventListener("mouseenter", () => this.pauseTimer());
        this.swiperContainer.addEventListener("mousemove", () => this.pauseTimer());
        this.swiperContainer.addEventListener("mouseleave", () => this.resumeTimer());
        this.resumeTimer();
      }
    }

    initSwiper() {
      this.mySwiper = new Swiper(this.querySelector('.swiper-container'), {
        slidesPerView: this.productRowsPc,
        loop: this.loop,
        autoplay: false,
        spaceBetween: 20,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        observer: true,
        resizeObserver: true,
        scrollbar: {
          el: this.querySelector(`.rs_scrollbar`),
        },
        navigation: {
          nextEl: this.querySelector(`.btn-swiper-right`),
          prevEl: this.querySelector(`.btn-swiper-left`),
        },
        pagination: {
          el: this.querySelector(`.swiper-pagination`),
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: this.productRowsMb,
            spaceBetween: 20,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
          989: {
            slidesPerView: this.productRowsPad,
            spaceBetween: 20,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
          1200: {
            slidesPerView: this.productRowsSmallPc,
            spaceBetween: 20,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          }
        },
        on: {
          slideChange: () => {
            this.handleSlideChange();
          },
          slideChangeTransitionStart: () => {
            if (this.autoplay) {
              this.pauseTimer();
              this.pastTime = 0;
              this.renderProgress(0);
            }
          },
          slideChangeTransitionEnd: () => {
            if (this.autoplay) {
              this.resumeTimer();
            }
          },
        },
      })
    }

    destroySwiper() {
      this.mySwiper.destroy()
    }

    // 开关 Swiper
    handleSwiperOnScreenWidth() {
      if (window.innerWidth > 989) {
        if (this.useSwiperPc) {
          if (!this.mySwiper || this.mySwiper.destroyed) this.initSwiper();
        } else {
          if (!this.mySwiper || !this.mySwiper.destroyed) this.destroySwiper();
        }
      } else if (window.innerWidth > 768) {
        if (this.useSwiperPad) {
          if (!this.mySwiper || this.mySwiper.destroyed) this.initSwiper();
        } else {
          if (!this.mySwiper || !this.mySwiper.destroyed) this.destroySwiper();
        }
        // if (!this.useSwiperPad) this.mySwiper.destroy();
        // else this.mySwiper.init();
      } else {
        if (this.useSwiperMb) {
          if (!this.mySwiper || this.mySwiper.destroyed) this.initSwiper();
        } else {
          if (!this.mySwiper || !this.mySwiper.destroyed) this.destroySwiper();
        }
        // if (!this.useSwiperMb) this.mySwiper.destroy();
        // else this.mySwiper.init();
      }
    }

    resumeTimer() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.pastTime += 20;
        // set progress
        this.renderProgress(this.pastTime / this.slideTime);
        if (this.pastTime >= this.slideTime) {
          this.pastTime = 0;
          // handle next slide
          this.mySwiper.slideNext();
        }
      }, 20);
    }

    pauseTimer() {
      clearInterval(this.timer);
    }

    handleSlideChange() {
      if (!this.mySwiper) return;
    }

    /**
     * 进度条
     * @param {Number} progress  0-1
     */
    renderProgress(progress) {
      const bullets = this.querySelectorAll(".swiper-pagination-bullet");
      for (const bullet of bullets) {
        if (!bullet.classList.contains("swiper-pagination-bullet-active")) {
          bullet.style.setProperty("--progress", "0");
        } else {
          bullet.style.setProperty("--progress", progress);
        }
      }
    }

    createCountdown() {
      // 倒计时相关
      const dateEl = $(this.querySelector(".countdown__item.day>span"));
      const hourEl = $(this.querySelector(".countdown__item.hour>span"));
      const minuteEl = $(this.querySelector(".countdown__item.minute>span"));
      const secondsEl = $(this.querySelector(".countdown__item.seconds>span"));

      const formatNumber = (num) => {
        if (num < 10) {
          return `0${num}`;
        } else {
          return num;
        }
      }

      setInterval(function () {
        // 获取目标时间
        const targetTime = new Date(`{{ se_stts.countdown_datetime }}`);
        // 获取当前时间
        const currentTime = new Date();
        // 获取时间差
        const diffTime = targetTime - currentTime;
        if (diffTime <= 0) {
          dateEl.html("00");
          hourEl.html("00");
          minuteEl.html("00");
          return;
        }
        // 计算时间差day
        const day = Math.floor(diffTime / 86400000);
        const dayRemain = Math.floor(diffTime % 86400000);
        // 计算小时数
        const hours = Math.floor(dayRemain / 3600000);
        const hoursRemain = Math.floor(dayRemain % 3600000);
        // 计算分钟数
        const minutes = Math.floor(hoursRemain / 60000);
        const minutesRemain = Math.floor(hoursRemain % 60000);
        // 计算秒数
        const seconds = Math.floor(minutesRemain / 1000);
        // 更新
        dateEl.html(formatNumber(day));
        hourEl.html(formatNumber(hours));
        minuteEl.html(formatNumber(minutes));
        secondsEl.html(formatNumber(seconds));
      }, 1000);
    }
  }

  customElements.define("bfcm-sale-products", BfcmSaleProducts);
}
